import api from './api';
import type { Product, User } from '../types';

export interface ReviewSearchResult {
  id: string;
  productId: string;
  productName: string;
  productImageUrl: string | null;
  username: string;
  userAvatarUrl: string | null;
  rating: number;
  contentSnippet: string;
  helpfulCount: number;
  commentCount: number;
  createdAt: string;
}

export interface SearchResults {
  products: Product[];
  users: User[];
  reviews: ReviewSearchResult[];
  productTotalCount: number;
  userTotalCount: number;
  reviewTotalCount: number;
}

export const searchService = {
  async search(query: string, page = 1, pageSize = 20, type?: string): Promise<SearchResults> {
    const response = await api.get<SearchResults>('/search', {
      params: { q: query, page, pageSize, type },
    });
    return response.data;
  },
};
